export enum ApplicantStatus {
  NOT_REVIEWED = "not_reviewed",
  UNDER_REVIEW = "under_review",
  INTERVIEWED = "interviewed",
  APPROVED = "approved",
  SEND_FOR_APPROVAL = "send_for_approval",
  DECLINED = "declined",
  CANCELLED = "cancelled",
}

export const applicantStatusNames: { [key in ApplicantStatus]: string } = {
  [ApplicantStatus.NOT_REVIEWED]: "Not reviewed",
  [ApplicantStatus.UNDER_REVIEW]: "Under review",
  [ApplicantStatus.INTERVIEWED]: "Interviewed",
  [ApplicantStatus.APPROVED]: "Approved",
  [ApplicantStatus.SEND_FOR_APPROVAL]: "Send for approval",
  [ApplicantStatus.DECLINED]: "Declined",
  [ApplicantStatus.CANCELLED]: "Cancelled",
};
export const applicantStatusNamesToValues = {
  [applicantStatusNames.not_reviewed]: ApplicantStatus.NOT_REVIEWED,
  [applicantStatusNames.under_review]: ApplicantStatus.UNDER_REVIEW,
  [applicantStatusNames.interviewed]: ApplicantStatus.INTERVIEWED,
  [applicantStatusNames.approved]: ApplicantStatus.APPROVED,
  [applicantStatusNames.send_for_approval]: ApplicantStatus.SEND_FOR_APPROVAL,
  [applicantStatusNames.declined]: ApplicantStatus.DECLINED,
  [applicantStatusNames.cancelled]: ApplicantStatus.CANCELLED,
};
